module.exports = __webpack_public_path__ + "static/media/WAN HAI.2b3f5d5b.svg";